/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBoolean } from '../../factoriesAny.js';
export var booleanDependencies = {
  typedDependencies,
  createBoolean
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBoolean.generated.js
// module id = 1323
// module chunks = 2